/**
 * 將傳進來的 form 做統一的 validation 設定
 * @param form Form
 * @param button 送交form的按鍵
 * @param validate_params Validate plugin 的參數
 * @param before_observer form檢查完畢,送交form之前要呼叫的事件
 */

window.observeForm = function (form, validate_params, before_observer) {

    validate_params.submitHandler = function (form) {

        if (before_observer) {
            before_observer(form);
        }
    }
    // 將 form 跟 plugin 綁定
    $(form).validate(validate_params);
}

// ----------------------------------------------------------------
//                為了讓 validator 可以判斷同個名子的 input
//                ex. <input type="hidden" name="names[]" value="">
//                原本的只會判斷第一個欄位，就會通過了
// ----------------------------------------------------------------
$.validator.prototype.checkForm = function() {

    this.prepareForm();
    for (var i = 0, elements = (this.currentElements = this.elements()); elements[i]; i++) {
        if (this.findByName(elements[i].name).length !== undefined && this.findByName(elements[i].name).length > 1) {
            for (var cnt = 0; cnt < this.findByName(elements[i].name).length; cnt++) {
                this.check(this.findByName(elements[i].name)[cnt]);
            }
        } else {
            this.check(elements[i]);
        }
    }
    return this.valid();
};

// ----------------------------------------------------------------
//                設定預設的功能
// ----------------------------------------------------------------
$.validator.setDefaults({
    showErrors: function(map, errorList) {

        // there's probably a way to simplify this
        let focussed = document.activeElement;

        if (focussed) {
            let _rd_required = $(focussed).closest('.rd_show_validator_error');

            // 因為這裡取不到select的focus 所以只能把select的事件寫在下面
            if($(focussed).is("input, textarea, select") && _rd_required.find('.rd_notice').length > 0){
                _rd_required.find('.rd_notice').remove();
                $(focussed).css("border", "1px solid #CCCCCC");
            }
        }

        $.each(errorList, function(index, error) {

            let element = error.element;
            let target  = $(element).closest('.rd_show_validator_error');

            if($(element).is("input, textarea, select")){

                if($(target).find('.rd_notice').length > 0){
                    $(target).find('.rd_notice').remove();
                    $(element).css("border", "1px solid #CCCCCC");
                }
                $(element).css("border", "1px solid #dc3545");

            }else if($(element).is("select")){

                if($(target).find('.rd_notice').length > 0){
                    $(target).find('.rd_notice').remove();
                    $(element).closest('.rd_required').find('.selectric').css("border", "1px solid #CCCCCC");
                }
                $(element).closest('.rd_required').find('.selectric').css("border", "1px solid #dc3545");
                // 要綁定移除錯誤的事件
                $(element).on('change',function () {
                    if($(this).val() !== ''){
                        $(this).closest('.rd_required').find('.rd_notice').remove();
                        $(this).closest('.rd_required').find('.selectric').css("border", "1px solid #CCCCCC");
                    }
                });
            }
            $(target).append('<div class="rd_notice" style="width: 100%;margin-top: .25rem;font-size: 80%;color: #dc3545;">'+error.message+'</div>');
        });
    },
    invalidHandler: function (event, validator) {

        //若無錯誤則跳過以下步驟
        if (!validator.numberOfInvalids())
            return;

        // 以Class「rd_required」為基準，作為捲軸移動參考
        let obj = $(validator.errorList[0].element);
        let top = obj.closest(".rd_required").offset().top;

        $('html, body').animate({
            scrollTop: top
        }, 500);
    }
});


